<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 20 20"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 4.5H17.5V18C17.5 18.8284 16.8284 19.5 16 19.5H4C3.17157 19.5 2.5 18.8284 2.5 18V4.5Z" :stroke="fill"/>
    <rect :fill="fill" height="8" rx="0.5" width="1" x="9.5" y="8"/>
    <rect :fill="fill" height="8" rx="0.5" width="1" x="6" y="8"/>
    <rect :fill="fill" height="8" rx="0.5" width="1" x="13" y="8"/>
    <rect :fill="fill" height="1" rx="0.5" width="20" y="4"/>
    <path d="M7.32951 0.901943C7.37626 0.66823 7.58146 0.5 7.8198 0.5H12.1802C12.4185 0.5 12.6237 0.66823 12.6705 0.901942L13.3901 4.5H6.6099L7.32951 0.901943Z" :stroke="fill"/>
  </svg>

</template>

<script>

export default {
  name: 'Trash',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
